import styled from 'styled-components';


/*
====================================
CONTENEDOR GENERAL
====================================
*/

export const ManualMain = styled.main`
    width: 100%;
    box-sizing: border-box;

    padding: 1.6rem 2.75rem 4rem 2.75rem;

    font-family: 'Montserrat', sans-serif;

    color: #2B2B2B;

    @media (max-width: 700px) {
        padding: 1.2rem 1rem 3rem 1rem;
    }
`;


/*
====================================
VOLVER
====================================
*/

export const ManualVolver = styled.button`
    display: inline-flex;
    align-items: center;

    gap: 0.4rem;

    margin: 0 0 1.4rem 0;
    padding: 0;

    border: none;
    background: transparent;

    color: #18898D;

    font-family: 'Montserrat', sans-serif;
    font-size: 0.8rem;
    font-weight: 700;

    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;


/*
====================================
CABECERA
====================================
*/

export const ManualCabecera = styled.header`
    width: 100%;
    max-width: 940px;
`;


export const ManualBadge = styled.div`
    display: inline-flex;
    align-items: center;

    margin-bottom: 0.7rem;
    padding: 0.32rem 0.75rem;

    background-color: #EAF7F7;

    border-radius: 999px;

    color: #18898D;

    font-size: 0.65rem;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.04em;
`;


export const ManualTitulo = styled.h1`
    margin: 0;

    color: #2B2B2B;

    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1.2;

    @media (max-width: 700px) {
        font-size: 1.45rem;
    }
`;


export const ManualBajada = styled.p`
    max-width: 760px;

    margin: 0.75rem 0 0 0;

    color: #646464;

    font-size: 0.88rem;
    line-height: 1.65;
`;


/*
====================================
INTRODUCCIÓN
====================================
*/

export const ManualIntroduccion = styled.div`
    max-width: 940px;

    margin-top: 1.5rem;
    padding: 1rem 1.2rem;

    box-sizing: border-box;

    background-color: #FAFCFC;

    border: 1px solid #E0E8E8;
    border-radius: 12px;

    color: #4C5858;

    font-size: 0.8rem;
    line-height: 1.6;

    p {
        margin: 0;
    }
`;


/*
====================================
ÍNDICE
====================================
*/

export const ManualIndice = styled.nav`
    width: 100%;
    max-width: 940px;

    margin-top: 2rem;
    padding: 1.3rem 1.5rem;

    box-sizing: border-box;

    background-color: #F7FBFB;

    border: 1px solid #DCEAEA;
    border-radius: 16px;
`;


export const ManualIndiceTitulo = styled.h2`
    margin: 0 0 1rem 0;

    color: #2B2B2B;

    font-size: 1rem;
    font-weight: 700;
`;


export const ManualIndiceGrid = styled.div`
    display: grid;

    grid-template-columns:
        repeat(2, minmax(0, 1fr));

    gap: 0.55rem 1rem;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;


export const ManualIndiceItem = styled.button`
    display: flex;
    align-items: flex-start;

    gap: 0.7rem;

    width: 100%;

    padding: 0.7rem 0.8rem;

    box-sizing: border-box;

    background-color: #FFFFFF;

    border: 1px solid transparent;
    border-radius: 10px;

    font-family: 'Montserrat', sans-serif;
    text-align: left;

    cursor: pointer;

    transition:
        border-color 0.15s ease,
        background-color 0.15s ease,
        transform 0.15s ease;

    &:hover {
        border-color: #BFE0DF;
        background-color: #F0FAFA;
        transform: translateY(-1px);
    }
`;


export const ManualIndiceNumero = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    width: 26px;
    height: 26px;

    background-color: #23AAAF;

    border-radius: 50%;

    color: #FFFFFF;

    font-size: 0.68rem;
    font-weight: 700;
`;


export const ManualIndiceTexto = styled.span`
    padding-top: 0.18rem;

    color: #3F4B4B;

    font-size: 0.78rem;
    font-weight: 600;
    line-height: 1.4;
`;


/*
====================================
CAPÍTULOS
====================================
*/

export const ManualCapitulo = styled.section`
    width: 100%;
    max-width: 940px;

    padding-top: 3rem;

    scroll-margin-top: 100px;
`;


export const ManualCapituloNumero = styled.div`
    margin-bottom: 0.3rem;

    color: #23AAAF;

    font-size: 0.67rem;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.04em;
`;


export const ManualCapituloTitulo = styled.h2`
    margin: 0 0 0.85rem 0;

    color: #2B2B2B;

    font-size: 1.3rem;
    font-weight: 700;
    line-height: 1.35;

    @media (max-width: 700px) {
        font-size: 1.15rem;
    }
`;


export const ManualSubtitulo = styled.h3`
    margin: 1.6rem 0 0.55rem 0;

    color: #2B2B2B;

    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.4;
`;


export const ManualTexto = styled.p`
    max-width: 820px;

    margin: 0.5rem 0;

    color: #4F5B5B;

    font-size: 0.82rem;
    line-height: 1.7;

    strong {
        color: #2B2B2B;
    }
`;


/*
====================================
PASOS
====================================
*/

export const ManualPasos = styled.div`
    display: flex;
    flex-direction: column;

    gap: 0.55rem;

    max-width: 820px;

    margin: 1rem 0;
`;


export const ManualPaso = styled.div`
    display: flex;
    align-items: flex-start;

    gap: 0.8rem;

    padding: 0.8rem 0.9rem;

    background-color: #FFFFFF;

    border: 1px solid #E5EAEA;
    border-radius: 10px;
`;


export const ManualPasoNumero = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    width: 25px;
    height: 25px;

    background-color: #23AAAF;

    border-radius: 50%;

    color: #FFFFFF;

    font-size: 0.68rem;
    font-weight: 700;
`;


export const ManualPasoTexto = styled.div`
    padding-top: 0.14rem;

    color: #4F5B5B;

    font-size: 0.8rem;
    line-height: 1.55;

    strong {
        color: #2B2B2B;
    }
`;


/*
====================================
CAJAS DESTACADAS
====================================
*/

export const ManualClave = styled.div`
    max-width: 820px;

    margin: 1rem 0;
    padding: 0.9rem 1rem;

    box-sizing: border-box;

    background-color: #EAF7F7;

    border-left: 4px solid #23AAAF;
    border-radius: 8px;

    color: #355959;

    font-size: 0.8rem;
    line-height: 1.6;

    strong {
        color: #18898D;
    }
`;


export const ManualImportante = styled.div`
    max-width: 820px;

    margin: 1rem 0;
    padding: 0.9rem 1rem;

    box-sizing: border-box;

    background-color: #FFF7E8;

    border-left: 4px solid #E7973C;
    border-radius: 8px;

    color: #66523A;

    font-size: 0.8rem;
    line-height: 1.6;

    strong {
        color: #B56A1D;
    }
`;


export const ManualAdvertencia = styled.div`
    max-width: 820px;

    margin: 1rem 0;
    padding: 0.9rem 1rem;

    box-sizing: border-box;

    background-color: #FFF0F1;

    border-left: 4px solid #D76970;
    border-radius: 8px;

    color: #69484B;

    font-size: 0.8rem;
    line-height: 1.6;

    strong {
        color: #B94E56;
    }
`;


/*
====================================
EJEMPLOS
====================================
*/

export const ManualEjemplo = styled.div`
    max-width: 820px;

    margin: 1rem 0;
    padding: 1rem 1.1rem;

    box-sizing: border-box;

    background-color: #F7F6FB;

    border: 1px solid #DDD7EE;
    border-radius: 12px;
`;


export const ManualEjemploTitulo = styled.div`
    margin-bottom: 0.65rem;

    color: #655EE8;

    font-size: 0.72rem;
    font-weight: 700;

    text-transform: uppercase;
`;


export const ManualEjemploFila = styled.div`
    display: flex;
    justify-content: space-between;

    gap: 1rem;

    padding: 0.35rem 0;

    border-bottom: 1px solid #E7E4F0;

    color: #4F5B5B;

    font-size: 0.78rem;
    line-height: 1.4;

    &:last-child {
        border-bottom: none;
    }

    strong {
        flex-shrink: 0;

        color: #2B2B2B;
    }
`;


/*
====================================
DEFINICIONES
====================================
*/

export const ManualDefiniciones = styled.div`
    display: grid;

    grid-template-columns:
        repeat(2, minmax(0, 1fr));

    gap: 0.75rem;

    max-width: 820px;

    margin: 1rem 0;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;


export const ManualDefinicion = styled.div`
    padding: 0.9rem 1rem;

    background-color: #FFFFFF;

    border: 1px solid #E4EAEA;
    border-radius: 10px;
`;


export const ManualDefinicionTitulo = styled.div`
    margin-bottom: 0.35rem;

    color: #18898D;

    font-size: 0.78rem;
    font-weight: 700;
`;


export const ManualDefinicionTexto = styled.div`
    color: #596565;

    font-size: 0.76rem;
    line-height: 1.55;
`;


/*
====================================
CAPTURAS
====================================
*/

export const ManualImagen = styled.figure`
    width: 100%;
    max-width: ${({ $ancho }) => {
        switch ($ancho) {
            case 'angosto':
                return '420px';
            case 'medio':
                return '620px';
            case 'grande':
                return '900px';
            case 'completo':
                return '100%';
            default:
                return '760px';
        }
    }};
    margin: 24px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    img {
        width: 100%;
        height: auto;
        display: block;
        border-radius: 16px;
        border: 1px solid #d9e3e8;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
        background: #fff;
    }
`;


export const ManualImagenPie = styled.figcaption`
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: #5f6c72;
`;


/*
====================================
CASOS FRECUENTES
====================================
*/

export const ManualCaso = styled.div`
    max-width: 820px;

    margin: 0.75rem 0;
    padding: 0.9rem 1rem;

    background-color: #FFFFFF;

    border: 1px solid #E4EAEA;
    border-radius: 10px;
`;


export const ManualCasoPregunta = styled.div`
    margin-bottom: 0.35rem;

    color: #2B2B2B;

    font-size: 0.8rem;
    font-weight: 700;
`;


export const ManualCasoRespuesta = styled.div`
    color: #596565;

    font-size: 0.77rem;
    line-height: 1.6;
`;


/*
====================================
RESUMEN FINAL
====================================
*/

export const ManualResumen = styled.div`
    max-width: 820px;

    margin-top: 1rem;

    overflow: hidden;

    border: 1px solid #DDE5E5;
    border-radius: 12px;
`;


export const ManualResumenFila = styled.div`
    display: grid;

    grid-template-columns:
        minmax(180px, 0.8fr)
        minmax(260px, 1.4fr);

    border-bottom: 1px solid #E7ECEC;

    &:last-child {
        border-bottom: none;
    }

    @media (max-width: 650px) {
        grid-template-columns: 1fr;
    }
`;


export const ManualResumenProblema = styled.div`
    padding: 0.75rem 0.9rem;

    background-color: #F7FBFB;

    color: #2B2B2B;

    font-size: 0.76rem;
    font-weight: 700;
`;


export const ManualResumenAccion = styled.div`
    padding: 0.75rem 0.9rem;

    color: #566262;

    font-size: 0.76rem;
    line-height: 1.5;
`;


/*
====================================
SEPARADOR
====================================
*/

export const ManualSeparador = styled.div`
    width: 100%;
    max-width: 940px;

    height: 1px;

    margin-top: 3rem;

    background-color: #E5EAEA;
`;